/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor.reducer';

export const DoctorDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorEntity = useAppSelector(state => state.doctor.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctor.detail.title">Doctor</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctor.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.id}</dd>
          <dt>
            <span id="firstName">
              <Translate contentKey="tinyMedicRestApp.doctor.firstName">First Name</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.firstName}</dd>
          <dt>
            <span id="middleName">
              <Translate contentKey="tinyMedicRestApp.doctor.middleName">Middle Name</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.middleName}</dd>
          <dt>
            <span id="lastName">
              <Translate contentKey="tinyMedicRestApp.doctor.lastName">Last Name</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.lastName}</dd>
          <dt>
            <span id="fullName">
              <Translate contentKey="tinyMedicRestApp.doctor.fullName">Full Name</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.fullName}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.doctor.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.doctor.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.doctor.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.modifiedBy}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctor.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctor.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctor.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.doctor.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctor.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.doctor.status">Status</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.status ? 'true' : 'false'}</dd>
          <dt>
            <span id="acceptAppointments">
              <Translate contentKey="tinyMedicRestApp.doctor.acceptAppointments">Accept Appointments</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.acceptAppointments ? 'true' : 'false'}</dd>
          <dt>
            <span id="acceptNewPatients">
              <Translate contentKey="tinyMedicRestApp.doctor.acceptNewPatients">Accept New Patients</Translate>
            </span>
          </dt>
          <dd>{doctorEntity.acceptNewPatients ? 'true' : 'false'}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctor.doctorDetails">Doctor Details</Translate>
          </dt>
          <dd>{doctorEntity.doctorDetails ? doctorEntity.doctorDetails.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctor.tmUser">Tm User</Translate>
          </dt>
          <dd>{doctorEntity.tmUser ? doctorEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctor.saluationId">Saluation Id</Translate>
          </dt>
          <dd>{doctorEntity.saluationId ? doctorEntity.saluationId.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor/${doctorEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorDetail;
